var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.351 188.747L129.88 192.624L126.003 196.152L122.475 192.275L126.351 188.747Z",
    fill: "#F19334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.213 131.899C25.7798 131.899 27.0501 130.629 27.0501 129.062C27.0501 127.495 25.7798 126.225 24.213 126.225C22.6462 126.225 21.376 127.495 21.376 129.062C21.376 130.629 22.6462 131.899 24.213 131.899ZM24.213 128.116C24.7353 128.116 25.1587 128.539 25.1587 129.062C25.1587 129.584 24.7353 130.007 24.213 130.007C23.6908 130.007 23.2674 129.584 23.2674 129.062C23.2674 128.539 23.6908 128.116 24.213 128.116Z",
    fill: "#F19334"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4369 192.857C54.5605 192.857 54.6608 192.757 54.6608 192.633C54.6608 192.509 54.5605 192.409 54.4369 192.409C54.3132 192.409 54.2129 192.509 54.2129 192.633C54.2129 192.757 54.3132 192.857 54.4369 192.857ZM54.4369 192.558C54.4781 192.558 54.5115 192.592 54.5115 192.633C54.5115 192.674 54.4781 192.708 54.4369 192.708C54.3956 192.708 54.3622 192.674 54.3622 192.633C54.3622 192.592 54.3956 192.558 54.4369 192.558Z",
    fill: "#F19334"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.79 35.8495L40.3567 36.472L40.9792 35.9054L41.5458 36.5279L42.1683 35.9613L41.6017 35.3388L42.2243 34.7722L41.6576 34.1496L41.0351 34.7163L40.4685 34.0938L39.846 34.6603L40.4126 35.2829L39.79 35.8495Z",
    fill: "#F19334"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.487 35.6491L179.834 38.2278L182.413 35.8809L184.76 38.4593L187.338 36.1122L184.991 33.534L187.57 31.187L185.223 28.6085L182.644 30.9553L180.298 28.377L177.719 30.7237L180.066 33.3022L177.487 35.6491Z",
    fill: "#F19334"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 97.2412C98.7696 97.2412 90.2002 105.811 90.2002 116.381V130.681H128.48V116.381C128.48 105.811 119.911 97.2412 109.34 97.2412Z",
    stroke: "#F19334",
    strokeWidth: 4.32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.781 71.9404H101.852C96.9968 71.9404 93.0605 68.0041 93.0605 63.1487V57.8604H111.989C116.844 57.8604 120.781 61.7966 120.781 66.652V71.9404Z",
    stroke: "#F19334",
    strokeWidth: 4.12848,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.781 69.3008V83.3808C120.781 89.9421 115.462 95.2608 108.901 95.2608C102.339 95.2608 97.0205 89.9421 97.0205 83.3808V71.0608",
    stroke: "#F19334",
    strokeWidth: 4.12848,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3594 113.96V96.373L93.2794 103.84L104.279 106.48L104.719 109.56L98.1194 117.92L85.8526 120.024L74.3594 113.96Z",
    fill: "#FEFEFE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3596 113.96C84.4796 122.32 90.1996 120.56 96.7996 118.8C103.4 117.04 112.2 106.04 100.76 104.28C89.3196 102.52 95.9196 103.84 80.5196 97.6799C72.8196 94.5999 68.0896 97.4599 65.2846 101.09C62.726 104.401 61.6766 108.631 62.1302 112.791C63.3856 124.3 61.5996 138.857 61.5996 145.2C61.5996 152.24 62.9196 153.56 62.9196 153.56C62.9196 153.56 66.8796 159.28 71.7196 165.88C76.5596 172.48 74.3596 176.88 74.3596 176.88C74.3596 176.88 73.9196 180.84 79.1996 180.84C84.4796 180.84 111.32 181.28 111.32 181.28C111.32 181.28 115.72 180.4 115.72 176C115.72 171.6 114.84 167.64 118.8 166.32C122.76 165 129.36 157.52 129.36 157.52",
    stroke: "#F19334",
    strokeWidth: 4.32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3594 96.0943V42.7693C74.3594 39.4042 77.0874 36.6758 80.4525 36.6758H134.266C137.631 36.6758 140.359 39.4042 140.359 42.7693V149.951C140.359 153.316 137.631 156.044 134.266 156.044H80.4525C77.0874 156.044 74.3594 153.316 74.3594 149.951V114.724",
    stroke: "#F19334",
    strokeWidth: 4.12848,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M156.287 80.3733C154.558 76.8621 150.31 75.4167 146.799 77.1451L140.8 80.0983V95.8952L153.059 89.8606C156.57 88.1323 158.015 83.8845 156.287 80.3733Z",
    stroke: "#F19334",
    strokeWidth: 4.43268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.46 104.28H142.34C138.816 104.28 135.96 107.333 135.96 111.1C135.96 114.867 138.816 117.92 142.34 117.92H152.46C155.983 117.92 158.84 114.867 158.84 111.1C158.84 107.333 155.983 104.28 152.46 104.28Z",
    fill: "#FEFEFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M152.46 104.28H142.34C138.816 104.28 135.96 107.333 135.96 111.1C135.96 114.867 138.816 117.92 142.34 117.92H152.46C155.983 117.92 158.84 114.867 158.84 111.1C158.84 107.333 155.983 104.28 152.46 104.28Z",
    stroke: "#F19334",
    strokeWidth: 4.82076,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.58 119.46H141.46C137.937 119.46 135.08 122.513 135.08 126.28C135.08 130.047 137.937 133.1 141.46 133.1H151.58C155.104 133.1 157.96 130.047 157.96 126.28C157.96 122.513 155.104 119.46 151.58 119.46Z",
    fill: "#FEFEFE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.58 119.46H141.46C137.937 119.46 135.08 122.513 135.08 126.28C135.08 130.047 137.937 133.1 141.46 133.1H151.58C155.104 133.1 157.96 130.047 157.96 126.28C157.96 122.513 155.104 119.46 151.58 119.46Z",
    stroke: "#F19334",
    strokeWidth: 4.82076,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.359 134.86H140.601C137.552 134.86 135.08 137.914 135.08 141.68C135.08 145.447 137.552 148.5 140.601 148.5H149.359C152.408 148.5 154.88 145.447 154.88 141.68C154.88 137.914 152.408 134.86 149.359 134.86Z",
    fill: "#FEFEFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M149.359 134.86H140.601C137.552 134.86 135.08 137.914 135.08 141.68C135.08 145.447 137.552 148.5 140.601 148.5H149.359C152.408 148.5 154.88 145.447 154.88 141.68C154.88 137.914 152.408 134.86 149.359 134.86Z",
    stroke: "#F19334",
    strokeWidth: 4.48452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8193 146.3H122.979",
    stroke: "#F19334",
    strokeWidth: 4.32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2522 43.1758C93.8441 43.1758 94.3247 43.6564 94.3247 44.2483C94.3247 44.8402 93.8441 45.3208 93.2522 45.3208C92.6603 45.3208 92.1797 44.8402 92.1797 44.2483C92.1797 43.6564 92.6603 43.1758 93.2522 43.1758Z",
    fill: "#F19334"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2522 43.1758C93.8441 43.1758 94.3247 43.6564 94.3247 44.2483C94.3247 44.8402 93.8441 45.3208 93.2522 45.3208C92.6603 45.3208 92.1797 44.8402 92.1797 44.2483C92.1797 43.6564 92.6603 43.1758 93.2522 43.1758Z",
    stroke: "#F19334",
    strokeWidth: 1.8
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.709 44.2695H118.776",
    stroke: "#F19334",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfie);
export default __webpack_public_path__ + "static/media/selfie.9c36e8fd5a8f84aeb81d2fed58c9e509.svg";
export { ForwardRef as ReactComponent };